@if (bootstrap.isLoading()) {
<div class="spinner-wrapper min-vh-100">
  <app-spinner size="m" type="ripple" />
  <p class="auth-waiting-message">{{ 'err.spa.waiting' | translate }}</p>
</div>
} @else {
<router-outlet />
}
